/* Wishlist — saved in this browser, no account needed (owner 2026-09-23).
   Storage: localStorage key `pkz:wishlist`, an array of product handles, newest first.
   The list never leaves the device: Shopify gives themes no writable customer storage from the
   storefront, so syncing across devices would need an app or a server of our own.
   Everything degrades quietly when storage is blocked (private mode): buttons still render,
   they just cannot remember. */
(function () {
  var KEY = 'pkz:wishlist';
  var MAX = 100;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
    catch (e) { /* storage blocked — the page still works */ }
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paintButton(btn) {
    var on = has(btn.dataset.wishlistToggle);
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
    var label = on ? btn.dataset.labelOn : btn.dataset.labelOff;
    if (label) btn.setAttribute('aria-label', label);
    var text = btn.querySelector('[data-wishlist-text]');
    if (text && label) text.textContent = label;
  }
  function paintAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(paintButton);
    var n = read().length;
    // The header heart: solid red when anything is saved, an empty outline when not
    document.querySelectorAll('[data-wishlist-link]').forEach(function (el) {
      if (n > 0) el.setAttribute('data-has-items', ''); else el.removeAttribute('data-has-items');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      var handle = btn.dataset.wishlistToggle;
      var nowOn = toggle(handle);
      paintAll();
      var page = document.querySelector('[data-wishlist-page]');
      if (page && !nowOn) {
        // on the "Любими" page a removed card leaves straight away
        var card = btn.closest('.product-card');
        if (card) card.remove();
        refreshPageState();
      } else if (page) {
        renderPage();
      }
      return;
    }
    var clear = e.target.closest('[data-wishlist-clear]');
    if (clear) {
      e.preventDefault();
      write([]);
      paintAll();
      renderPage();
    }
  });

  /* ---------- the "Любими" page ---------- */
  function refreshPageState() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var list = read();
    var empty = root.querySelector('[data-wishlist-empty]');
    var clear = root.querySelector('[data-wishlist-clear]');
    if (empty) empty.hidden = list.length > 0;
    if (clear) clear.hidden = list.length === 0;
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wishlist-grid]');
    var list = read();
    refreshPageState();
    if (!list.length) { grid.innerHTML = ''; return; }
    grid.innerHTML = '<p class="wl-loading">…</p>';
    // The cards are the theme's own: /products/<handle>?view=card renders
    // snippets/product-card.liquid on its own, without the layout.
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { return html ? { html: html, h: h } : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var good = items.filter(Boolean);
      // products that no longer exist drop out of the saved list
      if (good.length !== list.length) write(good.map(function (x) { return x.h; }));
      grid.innerHTML = good.map(function (x) { return x.html; }).join('');
      refreshPageState();
      paintAll();
    });
  }

  // so freshly appended cards ("Покажи още") get their hearts painted too
  window.PKZWishlist = { paint: paintAll };

  function init() { paintAll(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', paintAll);
})();
